import {
  WidgetType,
  MatchDecorator,
  Decoration,
  ViewPlugin,
  EditorView,
} from "@codemirror/view";

class EnumTokenWidget extends WidgetType {
  value;
  label;

  constructor(value, label) {
    super();
    this.value = value;
    this.label = label;
  }

  toDOM() {
    const span = document.createElement("span");

    span.textContent = this.label || this.value;
    span.className = "token-enum";
    return span;
  }
}

const createEnumTokenExtension = (enumValues) => {
  // Match each enum value as opposed to looking for a pattern.
  // We do this because an enum value can be a string containing any character
  // and pattern matching at this point becomes too complex, if not impossible to do with regex.
  const regexp = enumValues.length
    ? new RegExp(
        `{{enum.(${enumValues
          // Escape any special regexp characters
          .map((v) => v.value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
          .join("|")})}}`,
        "g",
      )
    : new RegExp("(?!)", "g"); // This will match nothing.

  const enumTokenMatcher = new MatchDecorator({
    regexp: regexp,
    decoration: (match) => {
      const option = enumValues.find((o) => o.value === match[1]);
      if (!option) return null;

      return Decoration.replace({
        widget: new EnumTokenWidget(match[1], option.label),
      });
    },
  });

  return ViewPlugin.fromClass(
    class {
      tokens;
      constructor(view) {
        this.tokens = enumTokenMatcher.createDeco(view);
      }
      update(update) {
        this.tokens = enumTokenMatcher.updateDeco(update, this.tokens);
      }
    },
    {
      decorations: (instance) => instance.tokens,
      provide: (plugin) =>
        EditorView.atomicRanges.of((view) => {
          return view.plugin(plugin)?.tokens || Decoration.none;
        }),
    },
  );
};

export default createEnumTokenExtension;
